import createNumberMask from 'text-mask-addons/dist/createNumberMask';
export const CurrencyMask = createNumberMask({
    prefix: 'R ',
    allowDecimal: true,
});
